import { render, staticRenderFns } from "./NavigationMenuPromoGroupCarousel.vue?vue&type=template&id=de4b0d74"
import script from "./NavigationMenuPromoGroupCarousel.vue?vue&type=script&lang=js"
export * from "./NavigationMenuPromoGroupCarousel.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuPromoGroupCarousel.vue?vue&type=style&index=0&id=de4b0d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports